/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import styled from "styled-components";
import { withStyles, Theme } from "@material-ui/core/styles";
import slotIcons from "components/images";
import Tooltip from "@material-ui/core/Tooltip";
import { useParams } from "react-router-dom";
import get from "lodash/get";
import Snackbar from "@material-ui/core/Snackbar";
import { Alert } from "components/modify/Save";

export interface IRouteParams {
  id: string;
}

function getIcon({ raffle, locked, player, code }) {
  if (locked) {
    return slotIcons["locked"];
  }

  if (raffle) {
    return slotIcons["raffle"];
  }

  if (player) {
    return slotIcons[`${code}_slotted`];
  }
  return slotIcons[code];
}

function getGroupImgProps({ groupIcon = "ErrorSymbol" }) {
  const side = groupIcon.split("_")[0];
  //default size
  let height = "50px";
  let width = "50px";

  //different sides icons need different heights/widths
  if (side === "opf") {
    height = "64px";
    width = "64px";
  }

  if (side === "nato") {
    height = "45px";
    width = "70px";
  }

  if (side === "ind") {
    height = "64px";
    width = "64px";
  }

  if (side === "civ") {
    height = "64px";
    width = "64px";
  }

  return {
    height: height,
    width: width,
    src: slotIcons[`${groupIcon}`],
  };
}

export const OrbatNode = ({ item, side, className }: any) => {
  const [modalOpen, setModalOpen] = useState(false);

  const groupIcon = get(item, "nodeData.group_data.group_orbat_icon");
  const groupImgProps = getGroupImgProps({ groupIcon });

  const { id } = useParams<IRouteParams>();

  const handleClose = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setModalOpen(false);
  };

  return (
    <>
      <NodeWrapper className={className}>
        <GroupWrapper>
          <GroupImageWrapper>
            <img {...groupImgProps} color="#b42126" />
          </GroupImageWrapper>
          <GroupNameWrapper>
            {get(item, "nodeData.group_data.group_name")}
          </GroupNameWrapper>
        </GroupWrapper>
        <SlotDisplayWrapper>
          {get(item, "nodeData.slots", []).map(
            (
              {
                slot_shortcode,
                slot_player = { player_name: {} },
                slot_name,
                slot_id,
                slot_gear,
                slot_dlc = [],
                slot_icon_code,
                slot_locked,
                slot_restricted,
                slot_raffle,
                raffle_entrants = [],
              },
              i
            ) => {
              const { player_name } = slot_player;

              return (
                <SlotWrapper
                  key={slot_shortcode + slot_id}
                  id={slot_shortcode + slot_id}
                  onClick={() => {
                    //wrap in if so that this doesn't trigger on create/new page where
                    //id && slot_id are both undefined
                    if (id && slot_id) {
                      setModalOpen(true);
                      navigator.clipboard.writeText(`!slot ${id}${slot_id}`);
                    }
                  }}
                >
                  <SlotTooltip
                    title={
                      <>
                        <table>
                          <tbody>
                            {id && slot_id && (
                              <tr>
                                <td>ID</td>
                                <td>{id + slot_id}</td>
                              </tr>
                            )}
                            {player_name && (
                              <tr>
                                <td>Player</td>
                                <td>{player_name}</td>
                              </tr>
                            )}
                            <tr>
                              <td>Name</td>
                              <td>{slot_name}</td>
                            </tr>
                            <tr>
                              <td>Gear</td>
                              <td>{slot_gear}</td>
                            </tr>
                            {/* {!!slot_dlc.length && (
                              <tr>
                                <td>DLC</td>
                                <td>{slot_dlc.join(" | ")}</td>
                              </tr>
                            )} */}
                          </tbody>
                        </table>
                        {slot_locked && (
                          <div style={{ color: "red" }}>
                            {" - Slot locked, will be opened at a later date."}
                          </div>
                        )}
                        {!!slot_restricted && (
                          <div style={{ color: "red" }}>
                            {" - Restricted Slot for members only."}
                          </div>
                        )}
                        {slot_raffle && (
                          <div>
                            <div style={{ color: "red" }}>
                              {" - This slot is to be raffled."}
                            </div>
                            <div style={{ color: "red" }}>
                              <div>{"Raffle Entrants :"}</div>
                              {raffle_entrants.map(({ player_name }) => {
                                return (
                                  <div style={{ display: "flex" }}>
                                    {"- "}
                                    <div key={player_name}>{player_name}</div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </>
                    }
                    arrow
                  >
                    <div id={"tooltipChildrenWrapper"}>
                      <div id={"icon"}>
                        <img
                          src={getIcon({
                            raffle: slot_raffle,
                            locked: slot_locked,
                            player: player_name,
                            code: slot_icon_code,
                          })}
                          width="32"
                          height="32"
                          key={i + slot_shortcode}
                          alt={slot_icon_code}
                        />
                        <div>{slot_shortcode}</div>
                      </div>
                      {!slot_raffle && (
                        <div id={"playerName"}>
                          {!player_name ? "-" : truncateUserName(player_name)}
                        </div>
                      )}
                    </div>
                  </SlotTooltip>
                </SlotWrapper>
              );
            }
          )}
        </SlotDisplayWrapper>
        <GroupGearWrapper
          gear={get(item, "nodeData.group_data.group_gear", "")}
        >
          {get(item, "nodeData.group_data.group_gear")}
        </GroupGearWrapper>
      </NodeWrapper>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={modalOpen}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="success">
          Copied slotting command to clipboard.
        </Alert>
      </Snackbar>
    </>
  );
};

function truncateUserName(name) {
  if (name.length > 10) {
    return `${name.substring(0, 8)}[...]`;
  }
  return name;
}

const NodeWrapper = styled.div`
  padding-left: 5px;
  padding-right: 5px;
  min-width: 200px;
  border-style: solid;
  border-color: "#3b618cCC";
  border-radius: 8px;
  background-color: #36393f;
  border-width: 2px;
  justify-content: center;
  color: #d3d3d4;
`;

const GroupWrapper = styled.div`
  border-bottom-style: solid;
  border-color: 6d6d6d;
  justify-content: center;
`;

const GroupGearWrapper = styled.div`
  border-top-style: ${(props) => props.gear && "solid"};
  border-color: ${(props) => props.gear && "6d6d6d"};
  border-width: ${(props) => props.gear && "3px"};
  padding-bottom: ${(props) => !props.gear && "3px"};
  justify-content: center;
`;

const GroupImageWrapper = styled.div`
  justify-content: center;
  padding-top: 5px;
  padding-bottom: 12px;
`;

const GroupNameWrapper = styled.div`
  margin-top: -15px;
  border-bottom-style: solid;
  border-color: 6d6d6d;
  justify-content: center;
`;

const SlotDisplayWrapper = styled.div`
  padding-top: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const SlotTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: "#36393f",
    border: "1px solid #3b618ccc",
    color: "#DADDE9",
    fontSize: "14px",
  },
}))(Tooltip);

const SlotWrapper = styled.div`
  padding: 3px 4px 2px 4px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: row;

  #tooltipChildrenWrapper {
    display: flex;
    flex-direction: row;
    width: 100%;
  }
  #icon {
    display: flex;
    flex-direction: row;
    min-width: 40%;
  }

  #playerName {
    flex-grow: 1;
  }
`;

export default OrbatNode;
